import { Button } from '@runeffective/evo-design-system'
import { Icon, Toaster } from '@ui'
import { useEffect, useState } from 'react'
import { DropTargetMonitor, useDrop } from 'react-dnd'
import css from './index.module.scss'
import { UseFloorHook } from '@providers/mapProvider'

interface UnassignEmployeeDropAreaProps {
  mapRef: any
}
export const UnassignEmployeeDropArea = ({ mapRef }: UnassignEmployeeDropAreaProps) => {
  const [dropProps, dropUnassignRef] = useDrop({
    accept: 'Employee',
    collect: (monitor: DropTargetMonitor) => ({
      item: monitor.getItem(),
    }),
  })

  const [showUnassignButton, setShowUnassignButton] = useState(false)
  const [buttonStyle, setButtonStyle] = useState({ transform: 'scale(1)' })
  useEffect(() => {
    setShowUnassignButton(!!dropProps?.item?.data?.seat)
  }, [dropProps])
  return (
    <div
      ref={dropUnassignRef}
      onDragOver={() => {
        setButtonStyle({ transform: 'scale(1.1)' })
      }}
      onDragLeave={() => {
        setButtonStyle({ transform: 'scale(1)' })
      }}
      onDrop={() => {
        mapRef?.actions?.unseatEmployee(dropProps?.item?.data)
      }}
    >
      {showUnassignButton && (
        <div className={css.unassignButtonWrpapper} style={buttonStyle}>
          <Icon name="solid fa-user-minus" light={true}></Icon>
          <Button size="default">Unassign</Button>
        </div>
      )}
    </div>
  )
}
